/* ASC-CUSTOM: product-card video — desktop: play on hover; touch: play while ≥60% in view.
   Loads nothing until needed (preload="none", sources kept in data-src), one video plays at a time,
   respects prefers-reduced-motion and Data Saver. Cards injected later (sliders, recommendations) are picked up. */
(function () {
  'use strict';
  if (window.__ascCardVideo) return;
  window.__ascCardVideo = true;
  var reduce = false, save = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  try { save = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}
  if (reduce || save) return; /* badge stays, no playback */
  var hoverable = false;
  try { hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) {}
  var current = null;
  var visible = new Map();

  function ready(v) {
    if (v.dataset.ascReady) return;
    var list = Array.prototype.slice.call(v.querySelectorAll('source[data-src]'));
    list.sort(function (a, b) { return (+a.dataset.height || 0) - (+b.dataset.height || 0); });
    var pick = null;
    for (var i = 0; i < list.length; i++) { if ((+list[i].dataset.height || 0) >= 480) { pick = list[i]; break; } }
    if (!pick) pick = list[list.length - 1];
    if (!pick) return;
    pick.setAttribute('src', pick.dataset.src);
    v.dataset.ascReady = '1';
    try { v.load(); } catch (e) {}
  }
  function card(v) { return v.closest('product-card') || v.parentNode; }
  function stop(v) {
    try { v.pause(); } catch (e) {}
    try { v.currentTime = 0; } catch (e) {}
    card(v).classList.remove('is-video-playing');
    if (current === v) current = null;
  }
  function play(v) {
    if (current && current !== v) stop(current);
    ready(v);
    current = v;
    if (!v.dataset.ascTracked) {
      v.dataset.ascTracked = '1';
      try {
        var card = v.closest('product-card, .grid-view-item, .product-card');
        if (window.asc && window.asc.track) window.asc.track('card_video_play', { handle: window.asc.handleOf(card), mode: hoverable ? 'hover' : 'scroll', list: location.pathname });
      } catch (e) {}
    }
    var p;
    try { p = v.play(); } catch (e) { p = null; }
    if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay refused: image stays */ });
  }
  var io = null;
  if (!hoverable && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.intersectionRatio >= 0.6) visible.set(e.target, e.intersectionRatio); else visible.delete(e.target);
      });
      var best = null, bestRatio = 0;
      visible.forEach(function (ratio, el) { if (ratio > bestRatio) { bestRatio = ratio; best = el; } });
      if (best) play(best); else if (current) stop(current);
    }, { threshold: [0, 0.6] });
  }
  function wire(v) {
    if (v.dataset.ascWired) return;
    v.dataset.ascWired = '1';
    var c = card(v);
    v.addEventListener('playing', function () { c.classList.add('is-video-playing'); });
    v.addEventListener('pause', function () { c.classList.remove('is-video-playing'); });
    if (hoverable) {
      c.addEventListener('mouseenter', function () { play(v); });
      c.addEventListener('mouseleave', function () { stop(v); });
      c.addEventListener('focusin', function () { play(v); });
      c.addEventListener('focusout', function () { stop(v); });
    } else if (io) {
      io.observe(v);
    }
  }
  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll('video[data-asc-card-video]'), wire);
  }
  scan(document);
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('visibilitychange', function () { if (document.hidden && current) stop(current); });
})();
